import { combineReducers, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';

import basket from './basket'

const reducers = combineReducers({
    basket
})

const store = createStore(
    reducers,
    applyMiddleware(thunk)
)

export default store